import React from 'react';
import { useSelector } from 'react-redux';
import { DomHelpers, StringHelpers } from 'e4shared';
import Bullet from 'components/prism/bullet';
import Toggle from 'components/prism/toggle';

export const Metrics = ({ data }) => {
    const [period, setPeriod] = React.useState('M');
    const loaded = React.useRef(null);
    const user = useSelector(state => state.user.user);

    const [explainer, setExplainer] = React.useState('');

    const resizeHandler = () => {
        const containers = document.getElementsByClassName('prism-metric-score-value');
        [...containers].map(x => DomHelpers.shrinkFont('label-text-fit', 32, x));
    };

    React.useEffect(() => {
        window.addEventListener('resize', resizeHandler);

        return () => {
            window.removeEventListener('resize', resizeHandler);
        };
    }, []);

    React.useEffect(() => {
        if (loaded?.current) {
            resizeHandler();
        }
    }, [loaded?.current]);

    React.useEffect(() => {
        switch (period) {
            case 'W':
                setExplainer('Compared to previous week');
                break;
            case 'M':
                setExplainer('Compared to previous month');
                break;
            case 'Q':
                setExplainer('Compared to previous quarter');
                break;
        }
    }, [period]);

    return (
        <div ref={loaded}>
            <div className="two-col flex flex-center mb10">
                <h2 className="flex-grow">Your Key Metrics</h2>
                <div className="text-right mr20">
                    <Toggle value={period} onChange={x => setPeriod(x)}>
                        <button value="W">Weeks</button>
                        <button value="M">Months</button>
                        <button value="Q">Quarters</button>
                    </Toggle>
                </div>
            </div>
            <div className="two-col">
                {data.map(item => (
                    <div key={`metric-${item.id}`} className="prism-metric">
                        <div className="prism-metric-name">{item.name}</div>
                        <div className="prism-metric-score">
                            <div className="prism-metric-score-value" style={{ overflow: 'hidden' }}>
                                <span className="label-text-fit">
                                    {StringHelpers.formatMetric(item.format, item.value, user.currencySymbol)}
                                </span>
                            </div>
                            <Bullet
                                icon={item.change >= 0 ? 'arrow-up' : 'arrow-down'}
                                value={`${item.change >= 0 ? item.change : item.change * -1}%`}
                                style={item.change >= 0 ? 'positive' : 'negative'}
                            />
                        </div>
                        <div className="mt10">{explainer}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Metrics;
